import http from "./http";
import { STATUS_SUCCESS } from "@/util/constants.js";

const createJob = (data) => {
  return http.post("/jobs", data);
};

const getJob = (params) => {
  return http.get("/jobs/job-paginated", { params });
};

const getJobFull = (params) => {
  return http.get("/jobs/job-by-id", {
    params,
  });
};

const getJobAddOn = (params) => {
  return http.get("/jobs/additional", {
    params,
  });
};

const getJobExpenses = (params) => {
  return http.get("/jobs/expenses", {
    params,
  });
};

const getStatusDriver = () => {
  return http.get("/jobs/status-driver");
};

const getReportJobByDriver = (params) => {
  return http.get("/jobs/jobs-paginated", {
    params,
  });
};

const getJobExpensesDriver = (params) => {
  return http.get("/jobs/job-expense-paginated", {
    params,
  });
};

const createJobExpenses = (data) => {
  return http.post("/jobs/job-expense", data);
};

const getRateTypesJobs = () => {
  return http.get("/jobs/job-rate-types");
};

const getJobPDF = (data) => {
  return http.post("/admin/download-pdf", data, { responseType: "blob" });
};

const getJobPDFDetails = (params) => {
  return http.get("/jobs/pdfs-exist", {
    params,
  });
};

const uploadFileReceiptJob = (formData) => {
  return http.post("/jobs/upload-receipt", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const uploadFileInvoiceJob = (formData) => {
  return http.post("/jobs/upload-invoice", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const uploadFileQuotationJob = (formData) => {
  return http.post("/jobs/upload-quotation", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const getFileUnSignByType = (data) => {
  return http.get(
    "/jobs/pdf",
    {
      params: {
        job_id: data.job_id,
        type_name: data.type_name,
      },
    },
    {
      responseType: "blob",
    }
  );
};

const getFileSignByType = (data) => {
  return http.get(
    "/jobs/pdf/signature",
    {
      params: {
        job_id: data.job_id,
        type_name: data.type_name,
      },
    },
    {
      responseType: "blob",
    }
  );
};

const getReportJobDownloadPdf = (data) => {
  return http.get(
    "/jobs/jobs-pdf",
    {
      params: {
        started_datetime: data.dateStart,
        ended_datetime: data.dateEnd,
      },
    },
    {
      responseType: "blob",
    }
  );
};

const getReportJobDownloadExcelByAdmin = (data) => {
  return http.get(
    "/jobs/jobs-export",
    {
      params: {
        started_datetime: data.dateStart,
        ended_datetime: data.dateEnd,
        filters: data.filters,
      },
    },
    {
      responseType: "blob",
    }
  );
};

const createJobDriver = (data) => {
  return http.post("/admin/driver", data);
};

const uploadFileDocJob = (formData) => {
  return http.post("/admin/upload-pdf", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const getDriverJob = (search) => {
  return http.get("/jobs/jobs-paginated", {
    params: {
      limit: search.perPage,
      page: search.page,
    },
  });
};

const getDriverJobById = (params) => {
  return http.get("/jobs/one-job-by-id", {
    params,
  });
};

const uploadJobDriverImages = (formData) => {
  return http.post("/employee/upload-image-route", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
const confirmDriverJob = (data) => {
  return http.put("/jobs/status", data);
};

const removeJob = (id) => {
  return http.post("/admin/job-remove", { job_id: id });
};

const saveFormJobRoutes = (jobId, jobRoutes) => {
  return http.put("/jobs/routes", {
    job_id: jobId,
    job_routes: jobRoutes,
  });
};

const saveFormJobRoutesById = (jobId, jobRoutes) => {
  return http.put("/jobs/route", {
    job_id: jobId,
    job_route: jobRoutes,
  });
};

const sendJobRoutes = (jobRouteId) => {
  return http.put("/jobs/status-route", {
    job_route_id: jobRouteId,
    status: STATUS_SUCCESS,
  });
};

const sendJobWarehouse = (data) => {
  return http.put("/jobs/distance-warehouse", data);
};

const sendJobAdditional = (jobId, jobAdditionalId) => {
  return http.put("/jobs/status-additional", {
    job_id: jobId,
    job_job_additional_id: jobAdditionalId,
    status: STATUS_SUCCESS,
  });
};

const sendJobPartTime = (data) => {
  return http.post("/jobs/finish-late-job", {
    job_id: data.job_id,
    ended_late_datetime: data.time,
    reason_late: data.remark,
  });
};

const getJobRouteImagesByType = (jobRouteId, jobImageType) => {
  return http.get(`/jobs/route-images`, {
    params: {
      job_route_id: jobRouteId,
      image_type: jobImageType,
    },
  });
};

const deleteJobRouteImagesByType = (data) => {
  return http.put("/jobs/delete/route-image", data);
};

const uploadJobRouteMile = (formData) => {
  return http.post("/jobs/mile-image", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const uploadJobRouteInvoice = (formData) => {
  return http.post("/jobs/invoice-image", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const uploadJobRouteProduct = (formData) => {
  return http.post("/jobs/product-image", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const getJobRouteMileImages = (route_id) => {
  return http.get(`/employee/job-route-mile-images`, {
    params: {
      route_id,
    },
  });
};
const deleteJobRouteMileImages = (images) => {
  return http.post("/employee/job-route-mile-image-delete", {
    images,
  });
};

const getJobRouteInvoiceImages = (route_id) => {
  return http.get("/employee/job-route-invoice-images", {
    params: {
      route_id,
    },
  });
};

const getJobRouteProductImages = (route_id) => {
  return http.get("/employee/job-route-product-images", {
    params: {
      route_id,
    },
  });
};

const deleteJobRouteInvoiceImages = (images) => {
  return http.post("/employee/job-route-invoice-image-delete", {
    images,
  });
};

const deleteJobRouteProductImages = (images) => {
  return http.post("/employee/job-route-product-image-delete", {
    images,
  });
};

const submitRoute = (data) => {
  return http.put("/employee/route", data);
};

const deleteJobRoute = (data) => {
  return http.post("/employee/job-route-delete", data);
};

const getImageByJobRouteId = (params) => {
  return http.get("/jobs/images-route", {
    params: {
      job_route_id: params.job_route_id,
    },
  });
};

export default {
  createJob,
  getJob,
  getJobFull,
  getJobAddOn,
  getJobExpenses,
  getJobExpensesDriver,
  getReportJobByDriver,
  getReportJobDownloadPdf,
  getReportJobDownloadExcelByAdmin,
  getJobPDF,
  getJobPDFDetails,
  getRateTypesJobs,
  getStatusDriver,
  createJobExpenses,
  createJobDriver,
  uploadFileDocJob,
  getDriverJob,
  getDriverJobById,
  uploadJobDriverImages,
  confirmDriverJob,
  removeJob,
  saveFormJobRoutes,
  saveFormJobRoutesById,
  sendJobRoutes,
  sendJobAdditional,
  sendJobWarehouse,
  sendJobPartTime,
  getJobRouteImagesByType,
  deleteJobRouteImagesByType,
  uploadJobRouteMile,
  getJobRouteMileImages,
  deleteJobRouteMileImages,
  uploadJobRouteInvoice,
  uploadJobRouteProduct,
  getJobRouteInvoiceImages,
  getJobRouteProductImages,
  deleteJobRouteInvoiceImages,
  deleteJobRouteProductImages,
  submitRoute,
  deleteJobRoute,
  getImageByJobRouteId,
  uploadFileReceiptJob,
  uploadFileInvoiceJob,
  uploadFileQuotationJob,
  getFileUnSignByType,
  getFileSignByType,
};
